<script>

///////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Icon
//
///////////////////////////////////////////////////////////////////////////////////////////////////////

import { defineComponent, ref, computed } from 'vue'


/**
 * Ex1
 * 
 * <template>
 *   
 *   <Icon width="2rem" height="2rem" style="fill:#0066CC;" icon="rounded-single-chevron-right"/>  
 * 
 * </template>
 * 
 * Ex2
 * 
 * <style scoped>
 *
 * .icon {
 *   transform:translateY(50%);
 *   fill:var(--link);
 * }
 *
 * </style>
 * 
 * <template>
 * 
 *   <Icon width="2rem" height="2rem" class="icon" icon="rounded-single-chevron-right"/>  
 * 
 * </template>
 */

export default defineComponent({
  name: "Icon",
  props: {
    icon: {
      type: String,
      required: false
    },
    fromProject: {
      type: Boolean,
      required: false, 
      default: false
    }
  },
  setup(props) {

    //The icon path and viewbox
    const iconPath = ref("")
    const iconViewBox = ref("")

    if(props.fromProject) {
      import(`@project/icons/${props.icon}.js`).then(val => {
        //the icon is just stored as a module with a path and viewBox string
        const { shapes, viewBox} = val
        iconPath.value = shapes
        iconViewBox.value = viewBox
      })
    } else {
      import(`@kit/assets/icons/${props.icon}.js`).then(val => {
        //the icon is just stored as a module with a path and viewBox string
        const { shapes, viewBox} = val
        iconPath.value = shapes
        iconViewBox.value = viewBox
      })
    }
  

    /**
     * Is the icon's path an array?
     * 
     */
    const iconIsMultiPath = computed(() => {
      const shapes = iconPath.value 
      if(shapes) {
        if(shapes.constructor == Array) {
          return true
        } else 
        if(shapes.constructor == String || shapes.constructor == Object) {
          return false
        }
      }
      return false
    })

    return { 
      iconPath,
      iconViewBox,
      iconIsMultiPath,
    }
  }
});
</script>

<template>

    <svg 
      v-if="iconPath"
      xmlns="http://www.w3.org/2000/svg" 
      :viewBox="iconViewBox"
      fill="currentColor">
      <template v-if="iconIsMultiPath">
        <template v-for="shape in iconPath">
          <template v-if="shape.type == 'path'">
            <path :d="shape.data"/>
          </template>
          <template v-else-if="shape.type == 'polygon'">
            <polygon :points="shape.data"/>
          </template>
        </template>
      </template>
      <template v-else>
        <path v-if="iconPath.type == 'path'" :d="iconPath.data"/>
        <polygon v-else-if="iconPath.type == 'polygon'" :points="iconPath.data" />
      </template>
    </svg>

</template>



